export const ROCKET_SITE_URL = 'https://www.rocketsearch.com.br/'
export const PARCEIROS_PATH = '/parceiros'
export const PARCEIROS_LOGIN_PATH = '/parceiros/login'
export const PARCEIROS_CADASTRO_PATH = '/parceiros/cadastro'
export const PARCEIROS_ACEITAR_PATH = '/parceiros/aceitar'

export const PARCEIROS_BG = '#0d0221'
export const PARCEIROS_ACCENT = '#e91e63'
export const PARCEIROS_LOGO = '/logo-rocket-dark.png'

export const fieldClass =
  'w-full rounded-xl border border-[var(--glass-border)] bg-[var(--bg-main)] px-4 py-3 text-sm text-text-primary outline-none placeholder:text-text-muted focus:border-[#e91e63]'

export const labelClass = 'text-[11px] font-medium uppercase tracking-wider text-text-muted'
